import {VGNav} from "vgnav";
import {VGSidebar} from "vgnav/src/VGSidebar";
import {VGLawCookie} from "vglawcookie";
import {VGFormSender} from "vgformsender";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.ScrollHeader.init($(window));
		VG.visibleBtnIfBigText();
		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.ScrollHeader.init($self);
		VG.cartSticky.init();
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization", "color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	visibleBtnIfBigText: () => {
		const textContainer = document.querySelectorAll('[data-visible-btn-container]');
		if (!textContainer) return;

		textContainer.forEach((el) => {
			const parent = el.getAttribute('data-visible-btn-container');
			if(!parent) return;

			const btn = el.closest(`.${parent}`).querySelector('[data-visible-btn]');
			if(!btn) return;

			let textBtn = btn.textContent;

			setTimeout(() => {
				const scrollHeight = el.scrollHeight;
				const height = el.offsetHeight;
				el.style.height = height + 'px';

				if (scrollHeight > height) {
					btn?.classList.add('d-block');
				} else {
					btn?.classList.add('d-none');
				}

				const btnListener = () => {
					btn.addEventListener('click', (e) => {
						if(textBtn === btn.textContent) {
							e.preventDefault();
							el.style.height = scrollHeight + 'px';
							el.style.display = 'block';
							btn.textContent = 'Свернуть'
						} else {
							e.preventDefault();
							el.style.height = height + 'px';
							btn.textContent = textBtn;
							el.style.display = '-webkit-box';
						}
					})
				}

				btnListener();
			}, 200)
		})
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] > img').each(function () {
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableFormSender();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'xl',
				toggle: '<i class="fa fa-chevron-down"></i>',
			}, {
				beforeClick: function () {
					let $sidebar = new VGSidebar('#vg-nav-sidebar');
					$sidebar.close({}, true);
				}
			});
		},

		enableAOS: function () {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function () {
			$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableFormSender: function () {
			const $forms = document.querySelectorAll('[data-vgformsender]');
			if ($forms.length) {
				$forms.forEach(function (form) {
					new VGFormSender(form).submit();
				});
			}
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="' + this.btn + '"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	ScrollHeader: {
		lastScrollTop: 0,
		body: $('body'),
		sticky: $('.header-wrapper'),

		init: function ($window) {
			let scroll = $window.scrollTop();

			if (scroll > 0) {
				this.sticky.addClass('scroll');

				if (scroll < this.lastScrollTop) {
					this.sticky.removeClass('fixed');
				} else {
					this.sticky.addClass('fixed');
				}
				this.lastScrollTop = scroll;
			}else if (scroll === 0) {
				this.sticky.removeClass('fixed');
				this.sticky.removeClass('scroll');
			}
		},
	},

	cartSticky: {
		cartSlider: document.querySelector('.cart-area [data-action="cart"]'),
		cartFixed: document.querySelector('.cart-fixed'),

		init: function () {
			if(window.innerWidth <= 576) return;
			const sticky = window.scrollY;
			const heightWindow = window.innerHeight;

			if(this.cartSlider && this.cartFixed) {
				if(sticky >= heightWindow) {
					this.cartSlider.classList.add('hidden');
					this.cartFixed.classList.add('active');
				} else {
					this.cartSlider.classList.remove('hidden');
					this.cartFixed.classList.remove('active');
				}
			}
		}
	},
}


export default VGListener;
